import {
	updateFilters,
	getDynFilterValues,
	setKeyFilterSelected,
} from "../../../redux/actions/photothequeActions";
import connect from "react-redux/es/connect/connect";
import Filter from "../../../components/filter/Filter";

const mapStateToProps = (state, ownProps) => {
	return {
		filters: state.phototheque.filters
			? state.phototheque.filters[ownProps.filterTargetKey]
			: [],
		currentFilters: state.phototheque.currentFilters
			? state.phototheque.currentFilters[ownProps.filterTargetKey]
			: [],
		deps:
			ownProps.depKey && state.phototheque.currentFilters
				? state.phototheque.currentFilters[ownProps.depKey] || []
				: [],
		filterTargetKey: ownProps.filterTargetKey,
		filterIdKey: ownProps.filterIdKey,
		filterLabelKey: ownProps.filterLabelKey,
		placeholder: ownProps.placeholder,
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		addFilter: values => {
			dispatch(updateFilters(ownProps.filterTargetKey, values));
		},
		setKeyFilterSelected: () =>
			dispatch(setKeyFilterSelected(ownProps.filterTargetKey)),
		getDynFilterValues: () =>
			dispatch(getDynFilterValues(ownProps.filterTargetKey)),
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Filter);



// WEBPACK FOOTER //
// src/containers/activite/phototeque/FilterContainer.js